import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import React, {useEffect, useState} from "react";
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import ApiService from "../ApiService";
import removeClass from "../util/RemoveCSS";

const ReportOrders = () => {
    const [records, setRecords] = useState(null);

    removeClass();
    useEffect(() => {
        async function getUsersReport() {
            try {
                const getUsersReport = await ApiService.getUsersReport();
                setRecords(getUsersReport.data);
            } catch(ex) {
                console.error(ex);
            }
        }
        getUsersReport();
    }, []);
    return (
        <Container fluid>
            <Row>
                <Col><p/></Col>
            </Row>
            <Row>
                <h2>Order Report</h2>
            </Row>
            <Row className="justify-content-md-center">
                <Col>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Order ID</th>    
                                <th>Ordered By</th> 
                                <th>Kit Details</th>
                                <th>Patient Info</th>                                
                                <th>Status</th>
                            </tr>    
                        </thead>
                        <tbody>
                            {renderData(records)}
                        </tbody>
                    </Table>
                </Col>
            </Row>

        </Container>
    )

}

const renderData = (records) => {
    if(!records){
        return ''
    }
    return records.map((record, idx) => {
        const {orderId, kitId, status} = record
        return (
            <tr key={idx}>
                <td>
                    <div>    
                        <h6>{orderId}</h6>
                    </div>    
                </td> 
                <td>
                    <div>{getOrderInfo(record)}</div>
                </td>
                <td>{kitId}</td>
                <td>
                    {getPatientInfo(record)}
                </td>    
                <td>
                    <div>
                        <h6>{status}</h6>
                    </div>
                </td>    
            </tr>  
        )
    })
}

const getPatientInfo = (order) => {
    const {patientUser: patient} = order
    if(!patient){
        return (
            <>
                <span>No Address</span> <br/>
            </>
        )
    }
    const {firstName,lastName, email, phoneNumber } = patient
    return (
        <div>
            <span>{firstName} {lastName}</span> <br/>
            <span>{email}</span> <br/>
            <span>{phoneNumber}</span><br/>
        </div>
    )
}

const getOrderInfo = (order) => {
    const { address,inboundTracking,
        outboundTracking, orderEmail} = order
    const getAddress = (address) => {
        if(!address){
            return (
                <>
                    <span>No Address</span> <br/>
                </>
            )
        }
        const {first_name, last_name, address1, city, province_code, zip, phone} = address
        return (
            <>
                <span>{first_name} {last_name}</span> <br/>
                <span>{address1}</span> <br/>
                <span>{city}, {province_code} - {zip} </span><br/>
                <span>ph: {phone}</span><br/>
            </>
        )
    }
    const inUrl= 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + inboundTracking
    const outUrl= 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + outboundTracking
    return (
        <div> 
            {getAddress(address)}
            <span>{orderEmail}</span><br/>
            <span>tracking[in]: 
                <a target="_blank" href={inUrl}>
                    {inboundTracking}
                </a>
                </span><br/>
            <span>tracking[out]: 
                <a target="_blank" href={outUrl}>
                    {outboundTracking}
                </a>                
            </span>
        </div>
    )
}
export default ReportOrders